import React from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { NamedLink, SecondaryButton } from '../../components';

import css from './ModalMissingInformation.module.css';

/**
 * Profile-photo reminder (D46): after a specialist's signup or after a published service.
 * The h2 names the dialog; both actions close it (the primary one also opens the profile settings).
 *
 * @param {Object} props
 * @param {string?} props.className
 * @param {'Signup'|'Publish'} props.moment which text to show
 * @param {Function} props.onClose
 */
const PhotoReminder = props => {
  const { className, moment, onClose } = props;

  return (
    <div className={className}>
      <h2 className={css.modalTitle}>
        <FormattedMessage id={`ModalMissingInformation.photoReminderTitle${moment}`} />
      </h2>
      <p className={css.modalMessage}>
        <FormattedMessage id={`ModalMissingInformation.photoReminderText${moment}`} />
      </p>
      <div className={css.photoReminderActions}>
        <NamedLink
          name="ProfileSettingsPage"
          className={css.reminderModalLinkButton}
          onClick={onClose}
        >
          <FormattedMessage id="ModalMissingInformation.photoReminderAddPhoto" />
        </NamedLink>
        <SecondaryButton type="button" onClick={onClose}>
          <FormattedMessage id={`ModalMissingInformation.photoReminderDismiss${moment}`} />
        </SecondaryButton>
      </div>
    </div>
  );
};

export default PhotoReminder;
